/** Canonical backend codes — clients.profile_metadata (validated by document-parser PATCH). */

export const MARKETING_AREA_OPTIONS = [
  { value: 'PROVINSI', label: 'Provinsi' },
  { value: 'NASIONAL', label: 'Nasional' },
  { value: 'INTERNASIONAL', label: 'Internasional' },
];

export const MARKETING_SYSTEM_OPTIONS = [
  { value: 'RETAIL', label: 'Retail' },
  { value: 'NON_RETAIL', label: 'Non retail' },
];
